// extracted by mini-css-extract-plugin
module.exports = {"info":"_4f5b0171","photo":"_a5d0d2d3","title":"_663416ff","description":"_ab184b59","button":"_8438eb69"};